import { LOCAL_STORAGE_MACHINE_TYPE_KEY } from './machine';

export const DESKTOP_ENVIRONMENT = localStorage.getItem(LOCAL_STORAGE_MACHINE_TYPE_KEY) === 'DESKTOP';
